module.exports = __webpack_public_path__ + "static/media/lifeLeadership.ef812212.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lifeLeadership.png
// module id = 45
// module chunks = 0